/**
 * DetailFacts element.
 */
import ChannelText from '@components/atoms/text/detailFactsChannelText';
import Container from '@components/atoms/container/detailFactsContainer';
import Context from '@shared/components/utils/context/detailContext';
import RestText from '@components/atoms/text/detailFactsRestText';
import { useContext } from 'react';

/**
 * Renders detail facts from context (`useMetadata` → `channelTitle`, `factsLine`).
 */
export default function DetailFacts() {
  const { metadata } = useContext(Context);
  const channelTitle = metadata?.channelTitle;
  const factsLine = metadata?.factsLine;
  if (!channelTitle && !factsLine) return null;

  return (
    <Container id='detailFactsContainer'>
      {channelTitle ? (
        <ChannelText id='detailFactsChannel'>{channelTitle}</ChannelText>
      ) : null}
      {factsLine ? (
        <RestText id='detailFactsRest' margin={!!channelTitle}>
          {channelTitle ? `| ${factsLine}` : factsLine}
        </RestText>
      ) : null}
    </Container>
  );
}
